import axios from "axios"
import {defineStore} from "pinia"
import {computed, ref} from "vue"

const urlCheckCard = 'api/v1/student/check'

export const useStudentStore = defineStore('StudentStore', () => {

	const isSubmitting = ref(false)
	const studentCardResponse = ref(null)

	const cardVerificationId = ref(null)
	const cardNumber = ref(null)
	const cardHolder = ref(null)

	const error = computed(() => {
		const status = studentCardResponse.value?.status

		if (status !== 'ok') {
			return studentCardResponse.value?.message
		}

		return ''
	})

	const studentCard = computed(() => {
		if(!error.value) {
			return {
				cardVerificationId: cardVerificationId.value,
				cardHolder: cardHolder.value,
				cardNumber: cardNumber.value
			}
		}

		return null
	})

	const resetStudentCard = () => {
		studentCardResponse.value = null
	}

	const resetErrorResponse = () => {
		if(error.value) {
			studentCardResponse.value = null
		}
	}

	const validateStudentCard = async (number, holder) => {
		return new Promise((resolve) => {
			isSubmitting.value = true
			axios.post(`${window.api.baseUrl}/${urlCheckCard}`, {
				card_number: number,
				card_holder: holder,
				user_id: window.init.userId || 0
			}, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then(({ data }) => {

				studentCardResponse.value = data
				const { status } = data

				if(status === 'ok') {
					cardVerificationId.value = data.verification_id
					cardNumber.value = number
					cardHolder.value = holder

					resolve(true)
				} else {
					resolve(false)
				}

			}).catch((err) => {
				console.log(err)
				//studentCardResponse.value = response.data
				resolve(false)
			}).finally(() => {
				isSubmitting.value = false
			})
		})
	}

	return {
		cardNumber,
		cardHolder,
		isSubmitting,
		error,
		studentCard,
		resetStudentCard,
		resetErrorResponse,
		validateStudentCard
	}
})